import { render, staticRenderFns } from "./logo-abx.vue?vue&type=template&id=3a5c5eb4&scoped=true&"
import script from "./logo-abx.vue?vue&type=script&lang=js&"
export * from "./logo-abx.vue?vue&type=script&lang=js&"
import style0 from "./logo-abx.vue?vue&type=style&index=0&id=3a5c5eb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5c5eb4",
  null
  
)

export default component.exports